module.exports = __webpack_public_path__ + "static/media/logo-header.fa552ac2.png";